/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1DeployGetDeploymentRequestBody = {
  /**
   * Unique deployment identifier to retrieve
   */
  deploymentId: string;
};

/** @internal */
export type V1DeployGetDeploymentRequestBody$Outbound = {
  deploymentId: string;
};

/** @internal */
export const V1DeployGetDeploymentRequestBody$outboundSchema: z.ZodType<
  V1DeployGetDeploymentRequestBody$Outbound,
  z.ZodTypeDef,
  V1DeployGetDeploymentRequestBody
> = z.object({
  deploymentId: z.string(),
});

export function v1DeployGetDeploymentRequestBodyToJSON(
  v1DeployGetDeploymentRequestBody: V1DeployGetDeploymentRequestBody,
): string {
  return JSON.stringify(
    V1DeployGetDeploymentRequestBody$outboundSchema.parse(
      v1DeployGetDeploymentRequestBody,
    ),
  );
}
